export const ENDPOINTS = {
  AZURE_BLOG: {
    FILE: 'file',
  },
  MEMBER: {
    SIGNUP: 'signup',
    SIGNIN: 'signin',
    AUTO_SIGNIN: 'auto-signin',
    VERIFY_OTP: 'verify--signin-otp',
    RESEND_OTP: 'resend--signin-otp',
    RESET_PASSWORD: 'reset-password',
    CHANGE_PASSWORD: 'change-password',
    VERIFY_PASSWORD: 'verify-password',
    CHECK_EMAIL_EXIST: 'check-email-exist',
    GET_ACCOUNT_DETAILS: 'get-account-details',
    GET_ACCOUNT_DETAILS_FOR_PAY_NOW: 'get-account-details-for-pay-now',
    UPDATE_ACCOUNT_DETAILS: 'update-account-details',
    GET_MEMBER_EMAIL: 'get-member-email',
    GET_MEMBERS_LIST: 'get-members',
    GET_REQUESTED_MEMBERS_LIST: 'get-requested-user-list',
    CREATE_MEMBER: 'add-member',
    DELETE_MEMBER: 'delete-member',
    UPDATE_MEMBER: 'update-member',
    UPDATE_MEMBER_PROFILE: 'update-member-profile',
    GET_MEMBER_By_ID: 'get-member-by-id',
    GET_MEMBER_DROPDOWN_BY_CUSTOMER: 'get-member-dropdown-by-customer',
    FORGOT_PASSWORD: 'forgot-password',
    INVITE_MEMBER: 'invite-member',
    UPDATE_INVITE_MEMBER: 'update-invite-member',
    SEND_OTP: 'send-update-email-otp',
    VERIFY_UPADTE_EMAIL_OTP: 'verify-update-email-otp',
    UPDATE_EMAIL: 'update-email',
    LOGOUT: 'logout',
    GET_SECURITY_QUESTIONS: 'get-security-questions',
    VERIFY_SECURITY_ANSWERS: 'verify-security-answers',
    SAVE_SECURITY_ANSWERS: 'save-security-answers',
    GET_FORGOT_PASSWORD_SECURITY_QUESTIONS:
      'get-forgot-password-security-questions',
    VERIFY_FORGOT_PASSWORD_SECURITY_ANSWERS:
      'verify-forgot-password-security-answers',
    GET_LOCKED_SECURITY_QUESTIONS: 'get-locked-security-questions',
    VERIFY_LOCKED_SECURITY_ANSWERS: 'verify-locked-security-answers',
    VERIFY_PRACTICE_INVITE_TOKEN: 'verify-invite-practice',
    DELETE_INVITATION: 'delete-invite',
    RESEND_INVITATION: 'resend-invite',
  },
  PICK_LIST: {
    GET_STATES: 'get-states',
    GET_PMS: 'get-pms',
    GET_MASTER_KPI_DASHBOARD_TILE: 'get-kpi-dashboard-tile',
    GET_MASTER_GRAPH: 'get-graphs-list',
    GET_PMS_VERSIONS: 'get-pms-versions'
  },
  ONBOARDING_STATUS: {
    GET_ONBOARDING_MILESTONES_BY_PRACTICE:
      'get-onboarding-milestones-by-practice',
  },
  // Task/3424 (Refund Authenticator) - ToothTeller-Controller-API's config controllers.
  REFUND_SETTLEMENT_TEMPLATE: {
    CREATE: 'create',
    GET_ALL_ACTIVE: 'get-all-active',
    GET_HISTORY: 'get-history',
  },
  REFUND_REASON_CODE: {
    CREATE: 'create',
    UPDATE: 'update',
    DELETE: 'delete',
    GET_BY_PRACTICE: 'get-by-practice',
  },
  REFUND_APPROVAL_RULE: {
    SAVE: 'save',
    GET_BY_PRACTICE: 'get-by-practice',
  },
  REFUND_SIGNATURE_SETTINGS: {
    SAVE: 'save',
    GET_BY_PRACTICE: 'get-by-practice',
  },
  PRACTICE: {
    //LIST: 'list',
    //GET_ALL_PRACTICE: 'get-all-practice',
    GET_PRACTICE_BY_ID: 'get-practice-by-id',
    //CREATE_PRACTICE: 'create-practice',
    UPDATE_PRACTICE: 'update-practice',
    //UPDATE_PRACTICE_PMS_CONFIG: 'update-practice-pms-config',
    UPDATE_PRACTICE_DATA_REFRESH_CONFIG: 'update-practice-data-refresh-config',
    GET_PRACTICE_DROPDOWN: 'get-practice-dropdown',
    GET_PRACTICE_DROPDOWN_BY_MEMBER_EMAIL:
      'get-practice-dropdown-by-member-email',
    UPDATE_AGREEMENT_ACCEPTANCE: 'update-agreement',
    UPDATE_SPECIFIC_ENTITY_OF_PRACTICE: 'update-specific-entity-of-practice',
    CREATE_PRACTICE_NO_AUTH: 'create-practice-no-auth',
    RESET_PRACTICE: 'reset-practice',
    GET_PRACTICE_ACCOUNT_STATUS: 'get-practice-account-status',
    UPDATE_WIDGET_STATUS_AS_DOWNLOAD: 'update-widget-status-as-downloaded',
    GENERATE_PAY_NOW_SCRIPT: 'generate-pay-now-script',
  },
  DATA_CONTEXT: {
    GET_LIST_BY_PMS_ID: 'list',
  },
  PRACTICE_CONFIG: {
    CREATE_PRACTICE_CONFIG: 'create-practice-config',
    GET_PRACTICE_CONFIGS: 'get-practice-configs',
    GET_SCHEDULE_CONFIG: 'get-schedule-config',
    GET_SCHEDULE_CONFIG_BY_ID: 'get-schedule-config-by-id',
    GET_ALL_SCHEDULE_CONFIG_LIST: 'get-all-schedule-config-list',
    GET_PMS_CONFIG: 'get-pms-config',
  },
  CMS: {
    GET_BY_ID: 'get-cms-by-id',
  },
  SCHEDULE_JOB: {
    CREATE_SCHEDULE_JOB: 'create-schedule-job',
    UPDATE_SCHEDULE_JOB: 'update-schedule-job',
  },
  SECURITY: {
    REPORT_PAGE_INTEGRITY_ISSUE: 'report-page-integrity-issue',
  },
  INSTALLER_VERSION: {
    LIST: 'list',
  },
  PAGE_VISIT: {
    TRACK: 'track',
  },
  USER_X_PRACTICE: {
    LIST: 'list',
    ADD_USER_PRACTICE: 'add-user-practice',
  },
  CUSTOMER: {
    GET_CUSTOMER_BY_ID: 'get-customer-by-id',
    UPDATE_AGREEMENT_ACCEPTANCE: 'update-agreement-acceptance',
    UPDATE_CUSTOMER: 'update-customer',
    CREATE_TENANTDB_AND_SUBSCRIPTION: 'create-tenantdb-and-subscription',
  },
  PAYMENTMETHODMASTER: {
    GET_PAYMENT_METHOD_MASTER_DROPDOWN: 'payment-method-dropdown',
  },
  ROLEMASTER: {
    GET_MENU_LIST_BY_CUSTOMER_SUBSCRIPTION:
      'get-menu-list-by-customer-subscription',
    CREATE_ROLE: 'create-role',
    UPDATE_ROLE: 'update-role',
    LIST: 'list',
    GET_BY_ID: 'get-role-master-by-id',
    GET_ROLEMASTER_BY_MEMBER: 'get-role-master-by-member',
    ROLE_MASTER_DROPDOWN_BY_PRACTICE_ID: 'get-role-master-dropdown-by-practice',
  },
  SUBSCRIPTION: {
    GET_MEMBER_SUBSCRIPTION_LIST: 'get-customer-subscription-list',
    GET_SUBSCRIBED_SUBSCRIPTION_LIST: 'get-subscribed-subscription-list',
    GET_SUBSCRIBED_SUBSCRIPTION_LIST_BY_PRACTICE_ID:
      'get-subscribed-subscription-by-practice-id',
    GET_SUBSCRIBED_SUBSCRIPTION_BY_ID: 'get-by-id',
    ACTIVATE_DEACTIVE_SUBSCRIPTION: 'activate-deactive-subscription',
    SHOW_COMMINICATION_BY_ID: 'show-communication-limit-by-id',
  },
  MODULE: {
    GET_MODULE_DROPDOWN: 'get-module-dropdown',
  },
  SHARED_FROM: {
    VERIFY_INVITE_LINK: 'verify-invite-code',
  },
  PAY_NOW : {
    VERIFY_PAYNOW_OTP: 'verify-paynow-otp',
    RESEND_PAYNOW_OTP: 'resend-paynow-otp',
  },
  TENANTS: {
    PRACTICE: {
      GET_PRACTICE_LIST: 'get-practice-list',
      GET_MAPPED_STATUS: 'get-practice-mapped-status',
    },
    CAMPAIGN: {
      GET_CAMPAIGN_LIST: 'get-campaigns-by-search-term',
      GET_CAMPAIGN_BY_ID: 'get-campaign',
      CREATE_OR_UPDATE_CAMPAIGN: 'create-or-update-campaign',
      GET_CAMPAIGN_PAID_PATIENTS: 'get-campaign-paid-patients',
    },
    CUSTOM_FILTER: {
      GET_CUSTOM_FILTERS: 'get-custom-filter-dropdown',
      GET_CUSTOM_FILTER: 'get-custom-filter-by-id',
      CREATE_CUSTOM_FILTER: 'create-custom-filter',
      UPDATE_CUSTOM_FILTER: 'update-custom-filter',
      DELETE_CUSTOM_FILTER: 'delete-custom-filter',
    },
    AR_AUTOMATION: {
      GET_AR_BY_DOS: 'get-ar-by-dos',
      GET_AR_BY_PATIENT: 'get-ar-by-patient',
      GET_AR_BY_PAYOR: 'get-ar-by-payor',
      GET_AR_BY_PAYOR_BY_ID: 'get-ar-by-payor-by-id',
      TARGET_LISTS: 'get-ar-targets',
      TARGET_LIST_BY_ID: 'get-ar-target-by-id',
      TARGETS_BY_PRACTICE_ID: 'get-ar-targets-by-practice-id',
      TARGET_LISTS_DETAILS: 'get-patients-by-ar-target',
      CREATE_TARGET_LISTS: 'create-ar-targets',
      EDIT_TARGET_LISTS: 'update-ar-targets',
      DELETE_TARGET_LISTS: 'delete-target-list',
    },
    PATIENT: {
      GET_TODAYS_PATIENT_LIST: 'get-todays-patient-list',
      GET_ALL_PATIENT_LIST: 'get-all-patient-list',
      GET_PATIENT_SUMMARY: 'get-patient-summary',
      GET_PATIENT_BILLING_SUMMARY: 'get-patient-billing-summary',
      EXPORT_TO_EXCEL_DOS: 'export-to-excel-dos',
      PATIENT_DROPDOWN: 'patient-dropdown',
      SYNC_NOW: 'sync-now',
      SEND_DEAD_LETTER_MESSAGES: 'send-dead-letter-messages',
      UPDATE_DEFAULT_PAYMENT_METHOD: 'update-patient-default-payment-method',
    },
    PROVIDER: {
      DROPDOWN_BY_PRACTICE: 'dropdown-by-practice',
    },
    INSURANCE_COMPANY: {
      DROPDOWN_BY_PRACTICE: 'dropdown-by-practice',
    },
    BILLING_ADDRESS: {
      GET_PATIENT_BILLING_ADDRESS: 'get-patient-billing-address',
      CREATE_PATIENT_BILLING_ADDRESS: 'create-patient-billing-address',
    },
    PRACTICE_ANALYTICS: {
      GET_All_FILTERS: 'filters',
      GET_RELATED_GRAPHS: 'related-graphs',
      GET_KPI_DASHBOARD_TILES: 'kpi-dashboard-tiles',
      GENERATE_GRAPH_EXCEL: 'generate-graph-excel',
      GET_REPORT_DOCUMENTS: 'report-documents',
      DELETE_REPORT_DOCUMENT: 'report-delete',
    },
    KPI_DASHBOARD: {
      UPDATE_KPI_DASHBOARD_TILE_CONFIG: 'update-kpi-dashboard-tile-config',
      GET_GRAPHS_AND_TILES_OF_PRACTICE: 'get-graphs-and-tiles-of-practice',
    },
    PRACTICE_ASSESSMENT: {
      CREATE_ASSESSMENT: 'create-assesment',
      UPDATE_ASSESSMENT: 'update-assesment',
      GET_ASSESSMENTS: 'get-assesments',
      GET_ASSESSMENT: 'get-assesment',
      UPLOAD_ASSESSMENT_FILE: 'upload-assesment-file',
      GET_ASSESSMENT_HISTORY: 'get-assesment-history',
      PRINT_ASSESSMENT: 'print-assesment',
    },
    CAMPAIGN_TEMPLATE: {
      GET_CAMPAIGN_TEMPLATES: 'get-campaign-templates',
      GET_CAMPAIGN_TEMPLATE: 'get-campaign-template',
      CREATE_CAMPAIGN_TEMPLATE: 'create-campaign-template',
      UPDATE_CAMPAIGN_TEMPLATE: 'update-campaign-template',
      GET_CAMPAIGN_TEMPLATES_DROPDOWN: 'get-campaign-templates-dropdown',
    },
    SMS_TEMPLATE: {
      GET_SMS_TEMPLATES_BY_SEARCH_TERM: 'get-sms-templates-by-seacrh-term',
      GET_SMS_TEMPLATES: 'get-sms-templates',
      GET_SMS_TEMPLATE: 'get-sms-template',
      CREATE_SMS_TEMPLATE: 'create-sms-template',
      UPDATE_SMS_TEMPLATE: 'update-sms-template',
      SMS_TEMPLATES_DROPDOWN: 'get-sms-templates-dropdown',
    },
    PAY_TYPE: {
      PAY_TYPE_DROPDOWN: 'pay-type-dropdown',
      PAY_TYPE_DROPDOWN_BY_PAYMENT_METHOD:
        'pay-type-dropdown-by-payment-method',
    },
    PAYMENT_METHOD_MAPPING: {
      CREATE_PAYMENT_METHOD_MAPPING: 'create-payment-method',
      UPDATE_PAYMENT_METHOD_MAPPING: 'update-payment-method',
      GET_PAYMENT_METHOD_MAPPING_BY_ID: 'get-payment-method-by-id',
      GET_ALL_PAYMENT_METHOD_MAPPING: 'get-all-payment-methods',
    },
    PAYMENT_DASHBOARD: {
      PAYMENT_ANALYTICS: 'analytics',
      PAYMENT_METHOD: 'method',
      CCPAYMENTTREDS: 'trend',
      OVERALL_TRENDS: 'overall-trend',
      OVERALL_PAYMENT_SNAPSHOT: 'snapshot',
    },
    PAYMENTPLAN_DASHBOARD: {
      PAYMENTPLAN_SNAPSHOT: 'plan-snapshot',
      PAYMENTPLAN_METHOD: 'method',
      PAYMENTPLAN_TYPE: 'type',
      TIMEBASED_SNAPSHOT: 'timebased-snapshot',
    },
    CUSTOM_FORM: {
      CREATE_CUSTOM_FORM: 'add-custom-form',
      UPDATE_CUSTOM_FORM: 'update-custom-form',
      GET_CUSTOM_FORMS: 'get-custom-forms',
      GET_CUSTOM_FORM: 'get-custom-form-by-id',
    },
    HOST_PAYMENT_PAGE: {
      GET_OTP: 'get-patient-instant-payment-otp',
      VERIFTY_OTP: 'verify-patient-otp',
      SEND_INSTANT_PAYMENT_LINK: 'send-instant-payment-link',
      CREATE_PAY_NOW_WITHOUT_SEARCH: 'create-pay-now-without-search',
      VALIDATE_PATIENT: 'validate-patient',
    },
    PRACTICE_CONFIGURATION: {
      CREATE_UPDATE: 'create-practice-configuration',
      GET_BY_MODULE_AND_PRACTICE:
        'get-practice-configuration-by-module-and-practice',
      CREAGET_ALL_BY_PRACTICE: 'get-all-practice-configuration-by-practice',
      RESET_PRACTICE: 'reset-practice',
      IS_ALLOW_PAY_NOW_ENABLED: 'is-allow-pay-now-enabled',
    },
    MEMBER_MODULE_REPORT: {
      GET_REPORT_BY_MODULE_MEMBER: 'get-member-reports',
      GET_ALL_REPORT_BY_MODULE_MEMBER: 'get-member-all-reports',
    },
    COMMUNICATION_TEMPLATE: {
      GET_COMMUNICATION_TEMPLATES: 'get-communication-templates',
      GET_COMMUNICATION_TEMPLATE: 'get-communication-template',
      CREATE_COMMUNICATION_TEMPLATE: 'create-communication-template',
      UPDATE_COMMUNICATION_TEMPLATE: 'update-communication-template',
      LIST_EMAIL_COMMUNICATION_TEMPLATES: 'list-email-communication-templates',
      GET_BY_ID_EMAIL_COMMUNICATION_TEMPLATE:
        'email-communication-template-by-id',
      CREATE_EMAIL_COMMUNICATION_TEMPLATE:
        'create-email-communication-template',
      UPDATE_EMAIL_COMMUNICATION_TEMPLATE:
        'update-email-communication-template',
      EMAIL_COMMUNICATION_TEMPLATE_DROPDOWN:
        'email-communication-templates-dropdown',
    },
    ARDashboard: {
      GET_AGING_BUCKET: 'aging-bucket',
      GET_SUMMARY_PAYOR: 'summary-payor',
      GET_AUTOMATION_CAMPIGNS: 'automation-campaigns',
      GET_AUTOMATION_CAMPIGN_STATUS: 'automation-campaign-status',
      GET_AUTOMATION_CAMPIGN_AMOUNT: 'automation-campaign-amount',
    },
    PAYMENTREPORT: {
      GET_SEND_PAYMENT_LINK_REPORT: 'get-send-payment-link-report',
      GET_TRANSACTION_HISTORY_REPORT: 'get-transaction-history-report',
      GET_FAILED_PAYMENTS_REPORT: 'get-failed-payments-report',
      GET_PAY_NOW_REPORT: 'get-pay-now-report',
      GET_OVERALL_TRENDS_REPORT: 'get-over-all-trends-report',
      GET_CC_PAYMENT_TRENDS_REPORT: 'get-cc-payments-trends-report',
      GET_PAYMENT_ANALYTICS_REPORT: 'get-payment-analytics-report',
      GET_WRITE_BACK_RETRY_REPORT: 'get-write-back-retry-report',
      EXPORT_WRITE_BACK_RETRY_REPORT: 'export-write-back-retry-report',
      EXPORT_TO_EXCEL_REPORT:'export-to-excel-report',
    },
    CARRIERMAPPING: {
      GET_CARRIER_MAPPING: 'get-carrier-mapping',
      ADD_UPDATE_CARRIER_MAPPING: 'add-or-update-carrier-mapping',
    },
    AR_REPORT: {
      GET_AR_DUE_BY_PATIENT_PROVIDER_REPORT:
        'get-ar-due-by-patient-provider-report',
      GET_CAMPAIGN_REPORT: 'get-campaign-report',
    },
    // OPERATORY_NOTES: {
    //   GET_NOTES_BY_PATIENT: 'get-notes-by-patient',
    // }
  },

  PAYMENTS: {
    INVOICE: {
      GET_INVOICES: 'get-invoice-list',
      GET_RECEIPT_BY_INVOICE_ID: 'get-receipt-by-invoice-id',
      INVOICE_RECIEPT_DOWNLOAD: 'invoice-reciept-download',

      GET_INVOICE_RECEIPT_BY_ID: 'get-invoice-reciept-by-invoiceId',
      DOWNLOAD_INVOICE_RECIEPT_BY_ID: 'download-invoice-reciept-by-invoiceId',
      PREVIEW_INVOICE: 'preview-invoice',
    },
    PAYMENT: {
      ADD_TOKENIZED_CARD: 'add-tokenized-card',
      CHARGE_CARD_TOKEN: 'charge-card-token',
      CHARGE_CARD: 'charge-card',
      CHARGE_CARD_PAY_NOW: 'pay-now-charge-card',
      CHARGE_ACH_TOKEN: 'charge-ach-token',
      GET_ACH_TRANSACTION_STATUS: 'get-ach-transaction-status',
      CASH_PAYMENT: 'cash-payment',
      CREATE_ACH_TOKEN: 'create-ach-token',
      DELETE_CARD_TOKEN: 'delete-card-token',
      TERMINAL_PAYMENT: 'terminal-payment',
      SEND_PAYMENT_LINK: 'send-payment-link',
      CHECK_PAYMENT: 'check-payment',
      GET_PAYMENT_NOTES: 'get-payment-notes',
      UPDATE_TOKEN_PREFERENCES: 'update-token-preference',
      UPDATE_TOKEN_BILLING_ADDRESS: 'update-token-billing-address',
      GET_TRANSACTIONS: 'get-transactions',
      EXPORT_TO_EXCEL_TRANSACTION: 'export-to-excel-transaction',
      REFUND_TRANSACTION: 'refund-transaction',
      GET_ACTION_REQUIRED: 'get-action-required',
      GET_TRANSACTION_BY_ID: 'get-transactions-by-id',
      GET_TAX: 'get-tax',
      CALCULATE_TAX: 'calculate-tax',
      GET_ORDER_BY_ID: 'get-order-by-id',
      GET_ORDER_BY_ORDER_ID: 'get-order-by-order-id',
      UPDATE_ORDER: 'update-order',
      CREATE_INVOICE: 'create-invoice',
      GET_TRANSACTION_HISTORY: 'get-practice-transaction-history',
      GET_ORDER_LIST: 'get-order-list',
      DOWNLOAD_ORDER: 'download-order',
      MAP_PATIENT: 'map-patient',
      PATIENT_RECIEPT_DOWNLOAD: 'patient-reciept-download',
      CANCEL_ORDER: 'cancel-order',
      CARD_DETAILS_BY_ORDER_ID: 'card-details-by-order-id',
      INACTIVE_ORDER: 'in-active-order',
      UPDATE_TRANSACTION_WB_STATUS: 'update-transaction-wb-status',
      CHECK_PAYMENT_PLAN_TRANSCTION: 'check-payment-plan-transaction'
    },
    PAYMENT_PLAN: {
      GET_CLEARENT_CUSTOMER_BY_PATIENT_ID:
        'get-clearent-customer-by-patient-id',
      CREATE_CLEARENT_CUSTOMER: 'create-clearent-customer',
      CREATE_UPDATE_PAYMENT_PLAN: 'create-update-payment-plan',
      DISCARD_UNPAID_PAYMENT_PLAN: 'discard-unpaid-payment-plan',
      UPDATE_PAYMENT_PLAN_INITIAL_AMOUNT: 'update-payment-plan-initial-amount',
      ADJUST_PAYMENT_PLAN: 'adjust-payment-plan',
      UPLOAD_SIGNED_CONTRACT: 'upload-signed-contract',
      GET_PAYMENT_PLAN_TEMPLATES: 'get-payment-plan-templates',
      GET_PAYMENT_PLAN_TEMPLATES_LIST: 'get-payment-plan-templates-list',
      CREATE_PAYMENT_PLAN_TEMPLATE: 'create-payment-plan-template',
      UPDATE_PAYMENT_PLAN_TEMPLATE: 'update-payment-plan-template',
      GET_PAYMENT_PLANS: 'get-payment-plans',
      GET_PAYMENT_PLANS_FOR_PRACTICE: 'get-payment-plans-for-practice',
      GET_PAYMENT_PLAN: 'get-payment-plan',
      GET_ACTION_REQUIRED: 'get-action-required',
      GET_PAYEMNT_PLAN_REPORT: 'get-payment-plan-report-list',
      GET_AUTOMATION_CAMPIGN_TOTALAMOUNT: 'automation-campaign-totalamount',
      GET_AUTOMATION_COLLECTION: 'automation-collection',
      SEND_PAYMENT_PLAN_EMAIL: 'send-payment-plan-email',
      GET_PAYMENT_PLAN_EMIS_BY_VERSION: 'get-payment-plan-emis-by-version',
      GET_PAYMENT_PLAN_SCHEDULE_INFO: 'get-payment-plan-schedules-info',
      PAYMENT_PLAN_DOWNLOAD: 'payment-plan-download',
    },
    TERMINAL: {
      CREATE_TERMINAL: 'create-terminal',
      UPDATE_TERMINAL: 'update-terminal',
      DELETE_TERMINAL: 'delete-terminal',
      GET_TERMINAL: 'get-terminals',
    },
    MERCHANT_ACCOUNT: {
      GET_BY_ID: 'get-merchant-account-by-id',
      GET_BY_PRACTICE_ID: 'get-merchant-account-by-practice-id',
      UPDATE: 'update-merchant-account',
      REGISTER_PAYLINK_WEBHOOK: 'register-paylink-webhook',
      GET_ALL_MERCHANT_ACCOUNT_BY_CUSTOMER_ID:
        'get-all-merchant-account-by-customer-id',
      GET_PRACTICE_MERCHANT_PUBLIC_KEY : 'get-practice-merchant-public-key'
    },
    TOKEN: {
      GET_CARD_TOKENS_BY_PATIENTS: 'get-card-tokens-by-patients',
      GET_CARD_TOKENS_BY_PRACTICE: 'get-card-tokens-by-practice',
    },
    // Task/3424 (Refund Authenticator) - ToothTeller-Payments-API's RefundMessageTemplateController.
    REFUND_MESSAGE_TEMPLATE: {
      LIST: 'list',
      SAVE: 'save',
      RESET: 'reset',
      PREVIEW: 'preview',
    },
    // Task/3424 (Refund Authenticator) - ToothTeller-Payments-API's RefundSettlementController.
    REFUND_SETTLEMENT: {
      CREATE_OFFER: 'create-offer',
      APPROVE_OFFER: 'approve-offer',
      REJECT_OFFER: 'reject-offer',
      GET_SIGNING_OFFER: 'signing-offer',
      SIGN_DIGITALLY: 'sign-digitally',
      REQUEST_SIGNING_CODE: 'request-signing-code',
      VERIFY_SIGNING_CODE: 'verify-signing-code',
      VERIFY_DATE_OF_BIRTH: 'verify-date-of-birth',
      UPLOAD_MANUAL_SIGNATURE: 'upload-manual-signature',
      GET_REGISTER: 'register',
      GET_REGISTER_SUMMARY: 'register-summary',
      RETRY_REFUND: 'retry-refund',
      SEND_REMINDER: 'send-reminder',
      GET_TRANSACTION_DETAILS: 'transaction-details',
      DOCUMENT: 'document',
      GET_TRANSACTION_REFUND_SUMMARY: 'transaction-refund-summary',
      GET_REFUNDABLE_PAYMENTS: 'refundable-payments',
    },
    PRE_PAYMENT: {
      GET_PRE_PAYMENTS: 'get-pre-payments',
      APPLY_PRE_PAYMENT: 'apply-pre-payment',
    },
    PROCESSOR: {
      GET_ALL_PROCESSOR: 'get-all-processor',
      CRAETE_PROCESSOR: 'create-processor',
      UPDATE_PROCESSOR: 'update-processor',
      GET_PROCESSOR_BY_ID: 'get-processor-by-id',
    },
    BILLING_ADDRESSES: {
      GET_BILLING_ADDRESS_BY_TRANSACTION_ID:
        'get-billing-address-by-transaction-id',
    },
  },
  TTINFOSETTING: {
    GET_DEFAULT: 'get-default-setting',
    GET_SECRETS: 'get-secrets',
  },
  CARRIERMASTER: {
    LIST: 'list',
    DROPDOWN_NO_AUTH: 'dropdown-no-auth',
  },
  CARRIERPLAN: {
    LIST: 'list',
  },
  PRACTICEAGREEMENTHISTORY: {
    CREATE: 'create',
    CREATE_NO_AUTH: 'create-no-auth',
  },
  POLICYDOCUMENTS: {
    GET_LATEST: 'get-latest',
    GET_BY_STATUS: 'get-by-status',
  },
  SHARED_AGREEMENT_FORM: {
    VERIFY_INVITE_LINK: 'verify-invite-token',
    PENDING_TOKEN: 'pending-token',
  },
  CREDIT: {
    GET_AVAILABLE_CREDIT: 'get-available-credit-by-practice-id',
    CREATE: 'create',
    DEBIT_CREDIT_AMOUNT: 'debit-credit-amount',
  },
  PRICINGPLAN: {
    GET_BY_ID: 'get-by-id',
  },
  SECURITY_QUESTIONS: {
    LIST: 'list',
  },
};
